import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
moment.locale('fr');

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss']
})
export class GamesComponent implements OnInit, AfterViewInit {

  paddingTop:string;

  @HostListener('window:scroll') onScroll(e: Event): void {
    if(window.scrollY > 0 && window.innerWidth > 992)
      this.paddingTop = window.scrollY+'px';
    else
      this.paddingTop = '0.5rem'
  }

  @ViewChild('dt')dt: any;

  title:string;

  filter:any = {
    editors: [],
    cats: [],
    player_:null,
    age_:null,
    coming:'0'
  };

  first = 0;

  games:any;

  sortOrder = -1;

  sortField:any = "dispoTimestamp";

  sortByMenu:any = [
    {label: "Nom", value:"name_item"},
    {label: "Date de sortie", value:"out_date_format"},
    {label: "Date de disponibilité", value:"dispoTimestamp"}
  ];

  showFilter = true;
  showSort = true;
  
  durations:any = [
    {label: "< 15min", value:"0_15"},
    {label: "15 - 30 min", value:"15_30"},
    {label: "30 - 60 min", value:"30_60"},
    {label: "1 - 2 h", value:"60_120"},
    {label: "> 2 h", value:"120_1000"}
  ];

  outMonth = parseInt(moment().format("M")) -1;
  private sub: any;

  selectMonth:any = [
    {label: moment().set('month', this.outMonth+2).format("MMMM YYYY"), value:parseInt(moment().format("M")) + 1},
    {label: moment().set('month', this.outMonth+1).format("MMMM YYYY"), value:parseInt(moment().format("M"))},
    {label: moment().format("MMMM YYYY"), value:parseInt(moment().format("M")) -1},
    {label: moment().set('month', this.outMonth-1).format("MMMM YYYY"), value:parseInt(moment().format("M")) -2},
    {label: moment().set('month', this.outMonth-2).format("MMMM YYYY"), value:parseInt(moment().format("M")) -3}
  ];

  constructor(public api:ApiService, private route: ActivatedRoute, private change:ChangeDetectorRef) { }

  activeGames:any;

  load:boolean = true;

  ngOnInit(): void {
    this.activeGames = this.api.games.filter(item => {
      if(item.active != '1'){
        item.orderable = false;
      }
      return true;
    });
    this.refresh();
  }

  refresh(): void {
    if(this.api.currentUrl == '/favoris'){
      this.title = "Mes favoris";
      this.showFilter= false;
      this.games = this.activeGames.filter(game => this.api.favs.findIndex(fav=>fav.ItemId == game.Id) > -1);
    }else if(this.api.currentUrl.indexOf('/pages/FAR') === 0){
        let id = this.api.currentUrl.replace('/pages/','').replace('-export','');
        let editor = this.api.editors.find(item => item.id_editor_ebp == id);
        if(editor){
          this.title = "Le catalogue "+ editor.name;
          this.showFilter= false;
          this.games = this.activeGames.filter(game => game.familyId == id);
          this.sortField = 'name_item';
          this.sortOrder = 1;
        }
    }else if(this.api.currentUrl.indexOf('/gss') === 0){
      this.title = "Catalogue GSS";
      this.showFilter= true;
      this.showSort = true;
      this.games = this.activeGames.filter(item=>{
        return item.xx_Jeux_catalogue_GSS == 1; 
      });
      this.sortField = 'name_item';
      this.sortOrder = 1;
    }else if(this.api.currentUrl.indexOf('/mon-top') === 0){
      this.title = "Mon top jeux";
      this.showFilter= false;
      this.showSort = false;
      this.games = this.activeGames.filter(item=>{
        return item.alreadyOrdered > 0; 
      });
      this.sortField = 'alreadyOrdered';
    }else if(this.api.currentUrl.indexOf('/sorties') === 0){
      this.title = "Sorties du mois";
      this.showFilter= false;
      this.sortField = 'out_date';
      this.games = this.activeGames.filter(item=>{
        return item.out_date != null && item.out_date.indexOf(moment().set('month', this.outMonth).format('YYYY-MM')) === 0; 
      });
    }else{
      this.games = this.activeGames;
    }

    /*let exp = this.games.map(item => { return {Editor: item.name_editor, Id:item.Id, name: item.name}});
    console.log(exp);*/
  }


  removeChip(chip,filter){
    if(filter == 'advanced'){
      this.filter[chip] = undefined;
      this.dt.filter(undefined,chip,'betweenMinMax');
      return false;
    }
      
      let i = this.filter[filter].findIndex(item=> chip == item);
      let array = this.filter[filter].splice(i,1);
      setTimeout(()=>{
        this.filter[filter] = [...this.filter[filter]];
        this.dt.filter(this.filter[filter],filter,'in');
      });
      return false;

  }
  
  getName(chip,filter){
    let item = this.api[filter].find(item=> chip == item.id);
    return item.name;
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.load = false;
    },1000);
    this.sub = this.route.params.subscribe(params => {

      if(params && params['filter']){
        setTimeout(()=>{
          this.filter = JSON.parse(this.api.base64_url_decode(params['filter']));
          if (this.filter.cats) {
            this.dt.filter(this.filter.cats, 'cats', 'arrayCompare');
          }
          if(this.filter.editors){
            this.dt.filter(this.filter.editors, 'editors', 'arrayCompare');
          }
          if(this.filter.query){
            this.dt.filterGlobal(this.filter.query,'contains')
          }
          if(this.filter.PriceListId){
            this.dt.filter(this.filter.PriceListId,'PriceListId','equals');
          }
          if(this.filter.player_){
            this.dt.filter(this.filter.player_,'player_','betweenMinMax');
          }
          if(this.filter.age_){
            this.dt.filter(this.filter.age_,'age_','betweenMinMax');
          }
          if(this.filter.coming){
            this.dt.filter(this.filter.coming,'coming','equals');
          }
          if(this.filter.orderable){
            this.dt.filter(this.filter.orderable,'orderable','equals');
          } 
          if(this.filter.rupture){
            this.dt.filter(this.filter.rupture, 'rupture', 'equals');
          }
          if(this.filter.duration)  {
            this.dt.filter(this.filter.duration, 'duration', 'betweenMinMax');
          }
        },0);
      }
    });
    this.dt.filterService.register('arrayCompare', (value, filter): boolean => {
      let intersection = value.filter(x => filter.includes(x));
      if(intersection.length > 0)
        return true;
      else
        return false;
    });
    this.dt.filterService.register('betweenMinMax', (value, filter): boolean => {

      if(filter == null || filter == undefined  || filter == 0)
        return true;
      if(value == null || value == undefined  || value == 0)
        return false;

      if(value.toString().indexOf("_") > -1){
        let [min,max] = value.split("_");
        if(filter >= min && filter <= max)
          return true;
      }

     if(filter.toString().indexOf("_") > -1){
        let [min,max] = filter.split("_");
        
        if(parseInt(value) >= min && parseInt(value) <= max){
          return true;
        }
      }

      return false;
    });
  }


  filterData(field,matchmode){
    this.dt.filter(this.filter.query,field,matchmode);
  }

  onFilter(event){
    this.sortField = undefined; 
    this.first = 0; 
    this.games = event.filteredValue;
     setTimeout(()=>{
        this.sortField = 'name_item'; 
        this.sortOrder = 1;     
     },100); 
      history.replaceState(null, '', 'games/' + this.api.returnBtoa(this.filter));
    
  }

  ngOnDestroy() {
    if(this.sub){
      this.sub.unsubscribe();
    }
  }
}
